import HeaderProvider from './hooks/useHeader';

import { HeaderProps } from './@types/HeaderProps';

const Desktop = (props: HeaderProps) => (
	<HeaderProvider {...props}>
		<div data-selection={props.componentId}>{props.children}</div>
	</HeaderProvider>
);
const Mobile = (props: HeaderProps) => (
	<HeaderProvider {...props}>
		<div data-selection={props.componentId}>{props.children}</div>
	</HeaderProvider>
);

export const Header = { Desktop, Mobile };
